import React from 'react';
import { ProjectSectionAsset } from '../../types/content';
import Button from '../UI/Button';
import Input from '../UI/Input';
import Card from '../UI/Card';

const isImage = (asset: ProjectSectionAsset) =>
  (asset.media?.contentType || '').startsWith('image/') || /\.(png|jpe?g|gif|webp|svg)$/i.test(asset.media?.url || asset.media?.fileName || '');

const ProjectSectionAssets: React.FC<{
  sectionKey: string;
  assets: ProjectSectionAsset[];
  onChange: (assets: ProjectSectionAsset[]) => void;
  onUpload: (index: number, file: File) => void;
}> = ({ sectionKey, assets, onChange, onUpload }) => {
  const rows = assets.filter((item) => item.sectionKey === sectionKey);
  const others = assets.filter((item) => item.sectionKey !== sectionKey);

  const updateRow = (index: number, patch: Partial<ProjectSectionAsset>) => {
    const next = [...rows];
    next[index] = { ...next[index], ...patch };
    onChange([...others, ...next]);
  };

  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center">
        <h3 className="text-sm font-semibold text-gray-900">Attachments</h3>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onChange([...assets, { sectionKey, title: '', displayOrder: assets.length + 1 }])}
        >
          Add file or image
        </Button>
      </div>
      {rows.map((asset, index) => (
        <Card key={`${sectionKey}-${index}`} className="p-4 space-y-3">
          <Input
            id={`${sectionKey}-asset-${index}`}
            label="Title"
            value={asset.title}
            onChange={(e) => updateRow(index, { title: e.target.value })}
          />
          <input
            type="file"
            accept="image/*,.pdf,application/pdf"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) onUpload(assets.findIndex((item) => item === asset), file);
            }}
          />
          {asset.media?.url && isImage(asset) && (
            <img src={asset.media.url} alt={asset.title} className="max-h-48 rounded-lg object-contain bg-gray-50" />
          )}
          {asset.media?.url && !isImage(asset) && (
            <a href={asset.media.url} target="_blank" rel="noreferrer" className="text-sm text-primary-700">
              {asset.media.fileName || asset.title || 'Open file'}
            </a>
          )}
          <button
            type="button"
            className="text-sm text-error-600"
            onClick={() => onChange(assets.filter((item) => item !== asset))}
          >
            Remove
          </button>
        </Card>
      ))}
    </div>
  );
};

export default ProjectSectionAssets;
